import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Button, Center, Heading, Text, VStack, useColorModeValue } from '@chakra-ui/react';
import { ArrowForwardIcon } from '@chakra-ui/icons';
import NextLink from 'next/link';
import handBottom from '../../../public/landing/hand_bottom.svg';
import handLeft from '../../../public/landing/hand_left.svg';
import handTop from '../../../public/landing/hand_top.svg';
export default function CTA() {
  return /*#__PURE__*/_jsx(Center, {
    background: "url(".concat(handLeft.src, ") no-repeat left bottom,url(").concat(handTop.src, ") no-repeat right top,url(").concat(handBottom.src, ") no-repeat calc(50% + 8rem) bottom"),
    backgroundColor: useColorModeValue('orange.50', 'inherit'),
    borderRadius: "10px",
    minH: "330px",
    textAlign: "center" // p={10}
    ,
    children: /*#__PURE__*/_jsxs(VStack, {
      h: "100%",
      children: [/*#__PURE__*/_jsx(Heading, {
        fontWeight: "900",
        children: "Curious yet?"
      }), /*#__PURE__*/_jsx(Text, {
        children: "It only takes a few minutes to get up and running!"
      }), /*#__PURE__*/_jsx(Box, {
        pt: 6,
        children: /*#__PURE__*/_jsx(NextLink, {
          passHref: true,
          href: "/demo",
          children: /*#__PURE__*/_jsx(Button, {
            colorScheme: "brand",
            rightIcon: /*#__PURE__*/_jsx(ArrowForwardIcon, {}),
            children: "See Demo Hub"
          })
        })
      })]
    })
  });
}